<svg viewBox="0 -10 1200 215" role="img"
  [attr.aria-label]="'Market and policy chart for fiscal year ' + year.year">
  <!-- One band per month, behind everything: purple where the month held an
       emergency decision, and lit while its rate column is hovered. -->
  @for (month of year.months; track month.month) {
    <rect [class]="'month-band month-' + month.month"
      [class.emergency]="hasEmergency(month.month)"
      [attr.x]="month.x - 46.3" y="6" width="92.66" height="194" />
  }
  @for (level of [1,4,7,10]; track level) {
    <text x="8" [attr.y]="192 - ((level - 1) / 9) * 156">{{ level }}</text>
  }
  <line class="axis" x1="44" x2="1156" y1="200" y2="200" />
  @for (month of year.months; track month.month) {
    <line class="axis-tick" [attr.x1]="month.x - 46.3" [attr.x2]="month.x - 46.3" y1="200" y2="206" />
  }
  <line class="axis-tick" x1="1156" x2="1156" y1="200" y2="206" />

  @for (series of visibleSeries; track series.definition.key) {
    @for (segment of series.segments; track $index) {
      <path [class]="'market-line ' + series.definition.key"
        [class.pre-fed]="series.definition.primary && segment.preFed"
        [class.positive]="series.definition.primary && segment.momentum > 0"
        [attr.stroke]="series.definition.color"
        [attr.stroke-dasharray]="series.definition.dash"
        [attr.d]="segment.path" />
    }
  }
  @for (series of visibleSeries; track series.definition.key) {
    @for (week of series.points; track week.weekStart; let weekIndex = $index) {
      <circle [class]="'week-dot ' + series.definition.key"
        [class.positive]="weekDotClass(series, weekIndex) === 'positive'"
        [class.negative]="weekDotClass(series, weekIndex) === 'negative'"
        [attr.fill]="series.definition.color"
        [attr.cx]="week.x" [attr.cy]="week.y" [attr.r]="series.definition.dotRadius">
        <title>{{ series.definition.statLabel }} {{ week.weekStart }} · {{ valueLabel(series, week.value) }} · score {{ week.score | number:'1.1-1' }}</title>
      </circle>
    }
  }
  @for (month of year.months; track month.month) {
    @for (dot of visibleDots(month); track dot.key) {
      <circle [class]="'month-dot ' + dot.key" [class.meeting]="dot.primary && month.meetingCount"
        [attr.stroke]="dot.color" [attr.cx]="month.x" [attr.cy]="dot.y"
        [attr.r]="dot.primary ? 7 : 6">
        <title>{{ monthLabels[month.month - 1] }} · score {{ dot.score | number:'1.1-1' }}</title>
      </circle>
    }
  }

  @for (marker of visibleEventMarkers; track marker.bank + marker.date) {
    <line class="event-rule" [class.boj]="marker.bank === 'BOJ'" [class.future]="marker.future"
      [attr.stroke]="bankColor(marker.bank)"
      [attr.x1]="marker.x" [attr.x2]="marker.x" y1="24" y2="194" />
    <rect class="event-flag"
      [attr.fill]="bankColor(marker.bank)"
      [attr.x]="marker.x - 4" y="10" width="8" height="8">
      <title>{{ marker.bank }} {{ meetingDateLabel(marker.date) }}</title>
    </rect>
    <!-- A rate change gets a marker that points down at its flag; it appears while
         the cursor is on that bank's row in the column for the same month. -->
    @if (marker.changed) {
      <path [class]="'event-arrow bank-' + bankClass(marker.bank) + ' month-' + marker.month"
        [attr.fill]="bankColor(marker.bank)"
        [attr.d]="'M ' + (marker.x - 4.5) + ' 0 L ' + (marker.x + 4.5) + ' 0 L ' + marker.x + ' 8 Z'" />
    }
  }
</svg>
